import styled from 'styled-components';
import {fontProps} from '../Properties/Properties';

const Span = styled.span`
    ${fontProps}
`;

export default Span;